import React, { createContext, useContext, useState, useMemo, useCallback } from 'react';

export const Context = createContext({});

export const Provider = (props) => {
  // Initial values are obtained from the props
  const { children } = props;

  const [visible, setVisible] = useState(false);
  const [showOverlay, _setShowOverlay] = useState(false);
  const [clearSearch, setClearSearch] = useState(false);
  const [selectedItem, _setSelectedItem] = useState(null);
  const [setter, setSetter] = useState(null);
  const [data, setData] = useState(null);
  const [title, setTitle] = useState(null);

  const showFilterList = useCallback((title, data, item, setterFn) => {
    setVisible(true);
    _setSelectedItem(item);
    setSetter(() => setterFn);
    setData(data);
    setTitle(title);
  }, []);

  const hideFilterList = useCallback(() => {
    setVisible(false);
    _setSelectedItem(null);
    setSetter(null);
    setData(null);
    setTitle(null);
  }, []);

  const handleTopLevelFilterClick = useCallback((label, data, item, setter) => {
    if (visible) {
      hideFilterList();
    } else {
      showFilterList(label, data, item, setter);
    }
  }, [visible, hideFilterList, showFilterList]);

  const setSelectedItem = useCallback((item) => {
    _setSelectedItem(item);
    setter(item);
  }, [setter]);

  const setShowOverlay = useCallback((value) => {
    _setShowOverlay(value);
  }, []);

  const filterContext = useMemo(
    () => ({
      clearSearch,
      setClearSearch,
      visible,
      setVisible,
      selectedItem,
      setSelectedItem,
      data,
      setData,
      title,
      setTitle,
      showFilterList,
      hideFilterList,
      handleTopLevelFilterClick,
      showOverlay,
      setShowOverlay,
    }),
    [
      clearSearch,
      visible,
      selectedItem,
      data,
      title,
      showOverlay,
      showFilterList,
      hideFilterList,
      handleTopLevelFilterClick,
      setSelectedItem,
      setShowOverlay,
    ],
  );

  return <Context.Provider value={filterContext}>{children}</Context.Provider>;
};

export const { Consumer } = Context;

export const useFilterContext = () => useContext(Context);
